export const redirects = {
  nitrogen: process.env.VUE_APP_URL_NITROGEN,
  planeja: process.env.VUE_APP_URL_PLANEJA,
  localhost: process.env.VUE_APP_URL_LOCAL,
};
